import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "decoration-purple",
  "use": "decoration-purple-usage",
  "viewBox": "0 0 172 131",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 172 131\" id=\"decoration-purple\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M171.417 117.486V0H2.865c-4.527 17.736-3.48 38.877 1.668 58.682 8.206 31.572 26.835 59.749 51.633 68.716 19.43 6.989 42.62 2.275 65.38-2.352 6.4-1.301 12.765-2.595 19.004-3.62 8.156-1.354 16.091-2.253 23.741-3.119 2.404-.273 4.78-.542 7.126-.821z\" fill=\"#583BB6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol